import inputmaskDirective from './directives/inputmask';
import debounceDirective from './directives/debounce';


export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.vueApp.directive('coreMask', inputmaskDirective);
  nuxtApp.vueApp.directive('coreDebounce', debounceDirective);

  // Refresh token on application load
  const refreshToken = localStorage.getItem('refresh_token');

  // This will be handled by middleware
  if (!refreshToken) {
    return;
  }

  // Just check if refresh token is valid and logout if not
  const { auth } = useRequest();
  const refreshTokenEvent = auth.authControllerRefreshToken({ token: refreshToken });

  try {
    const { payload: { accessToken, refreshToken: rt } } = await refreshTokenEvent;

    localStorage.setItem('token', accessToken);
    localStorage.setItem('refresh_token', rt);

    // Загружаем ресурсы страниц после обновления токена
    const { loadPageResources } = useRoles();

    await loadPageResources();
    await useFavoriteAccountsStore().refresh();
  } catch {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
  }
});
